import { Page } from 'components/shared/Page';
import { Section } from 'components/shared/Section';

const macInstructions = [
    <div key="1">
        <p>Select Outlook &gt; Preferences to open the Preferences dialog.</p>
        <img
            src="https://sseasacdn.blob.core.windows.net/strata-website/mac-1-preferences.png"
            className="sds_image__container"
            alt="Outlook preferences menu item"
            loading="lazy"
            width="300"
        />
    </div>,
    <div key="2">
        <p>Select Signatures.</p>
        <img
            src="https://sseasacdn.blob.core.windows.net/strata-website/mac-2-preferences-dialog.png"
            className="sds_image__container"
            alt="Outlook mail dialog"
            loading="lazy"
            width="300"
        />
    </div>,
    <div key="3">
        <p>
            Click the + beneath the list of signatures. A new signature line appears in the
            signature name list.
        </p>
        <img
            src="https://sseasacdn.blob.core.windows.net/strata-website/mac-3-signatures.png"
            className="sds_image__container"
            alt="Outlook email signatures"
            loading="lazy"
            width="300"
        />
    </div>,
    <div key="4">
        <p>
            Copy the signature from an email. It is best to do this in a reply and not directly from
            an email sent to you. Be sure to select the whole table by hovering and selecting the
            four way arrow in the top left.
        </p>
        <img
            src="https://sseasacdn.blob.core.windows.net/strata-website/mac-table-selection.png"
            className="sds_image__container"
            alt="Table selection"
            loading="lazy"
            width="300"
        />
    </div>,
    <div key="5">
        <p>
            Paste the signature from the email that was sent and update to your information. Add a
            Signature Name and save by clicking the floppy disk icon.
        </p>
        <img
            src="https://sseasacdn.blob.core.windows.net/strata-website/mac-4-edit-signature.png"
            className="sds_image__container"
            alt="Outlook edit email signature"
            loading="lazy"
            width="300"
        />
    </div>,
    <div key="6">
        <p>Select and assign signature you created to all New messages and Replies.</p>
        <img
            src="https://sseasacdn.blob.core.windows.net/strata-website/mac-5-default-signature.png"
            className="sds_image__container"
            alt="Outlook default signature"
            loading="lazy"
            width="300"
        />
    </div>,
    <div key="7">
        <p>
            <strong>IMPORTANT:</strong> Confirm that your signature looks correct.
        </p>
        <img
            src="https://sseasacdn.blob.core.windows.net/strata-website/example-email-signature.png"
            className="sds_image__container"
            alt="Example email signature"
            loading="lazy"
            width="300"
        />
        <ul>
            <li>Is the color correct for both the text and line?</li>
            <li>Is the spacing the same?</li>
            <li>Are only the first letters of your first and last name capitalized?</li>
            <li>Is the logo the right size?</li>
            <li>If anything is off, copy and paste it again rather than trying to fix it.</li>
        </ul>
    </div>,
];

const pcInstructions = [
    <div key="8">
        <p>Select File &gt; Options. The Outlook Options window opens.</p>
        <img
            src="https://sseasacdn.blob.core.windows.net/strata-website/pc-1-options.png"
            className="sds_image__container"
            alt="Outlook options menu item"
            loading="lazy"
            width="300"
        />
    </div>,
    <div key="9">
        <p>Select Mail.</p>
        <img
            src="https://sseasacdn.blob.core.windows.net/strata-website/pc-2-mail.png"
            className="sds_image__container"
            alt="Outlook mail menu"
            loading="lazy"
            width="300"
        />
    </div>,
    <div key="10">
        <p>Select Signatures…</p>
        <img
            src="https://sseasacdn.blob.core.windows.net/strata-website/pc-3-signatures.png"
            className="sds_image__container"
            alt="Outlook select signatures..."
            loading="lazy"
            width="300"
        />
    </div>,
    <div key="11">
        <p>Paste the signature from the email that was sent and update to your information.</p>
        <img
            src="https://sseasacdn.blob.core.windows.net/strata-website/pc-4-edit-signature.png"
            className="sds_image__container"
            alt="Outlook edit signature"
            loading="lazy"
            width="300"
        />
    </div>,
    <div key="12">
        <p>
            Select and assign the signature you created to all New messages and Replies/forwards.
            Select OK to save.
        </p>
        <img
            src="https://sseasacdn.blob.core.windows.net/strata-website/pc-5-default-signature.png"
            className="sds_image__container"
            alt="Outlook default signature"
            loading="lazy"
            width="300"
        />
    </div>,
    <div key="13">
        <p>
            <strong>IMPORTANT:</strong> Confirm that your signature looks correct.
        </p>
        <img
            src="https://sseasacdn.blob.core.windows.net/strata-website/example-email-signature.png"
            className="sds_image__container"
            alt="Example email signature"
            loading="lazy"
            width="300"
        />
        <ul>
            <li>Is the color correct for both the text and line?</li>
            <li>Is the spacing the same?</li>
            <li>Are only the first letters of your first and last name capitalized?</li>
            <li>Is the logo the right size?</li>
            <li>If anything is off, copy and paste it again rather than trying to fix it.</li>
        </ul>
    </div>,
];

export const EmailSignature = () => (
    <div>
        <Page
            pageTitle="Email Signature"
            pageDescription="Standard and brand approved email signatures are important for a strong brand. Instructions for both Mac and Windows can be found below. Do not use a different style for your signature and reach out with any questions."
            pageContent={
                <>
                    <Section title="Mac Instructions" contentArray={macInstructions} />
                    <Section title="PC Instructions" contentArray={pcInstructions} />
                </>
            }
        />
    </div>
);
